module.exports = __webpack_public_path__ + "static/media/box.b05dc040.svg";